
    import './styles.scoped.css';
    export default {
  "selectable-item": "_selectable-item_7fejm_3",
  "has-background": "_has-background_7fejm_28",
  "highlighted": "_highlighted_7fejm_31",
  "selected": "_selected_7fejm_31",
  "is-keyboard": "_is-keyboard_7fejm_48",
  "parent": "_parent_7fejm_51",
  "child": "_child_7fejm_57",
  "disabled": "_disabled_7fejm_63",
  "virtual": "_virtual_7fejm_69",
  "measure-strut": "_measure-strut_7fejm_77",
  "measure-strut-first": "_measure-strut-first_7fejm_86"
};
  